import { ReactElement } from 'react';

import { SingleChoiceQuestion, SingleChoiceQuestionProps, Value } from './SingleChoiceQuestion';

const PreApprovalSingleChoiceQuestion = <T extends Value>(props: SingleChoiceQuestionProps<T>): ReactElement => (
  <SingleChoiceQuestion
    {...props}
    radioColor='black'
    titleProps={{ color: 'neutral.plum.1000', variant: 'subtitle1', mb: '1rem' }}
  />
);

export default PreApprovalSingleChoiceQuestion;

